<template>
  <div class="md-layout md-layout-item md-size-70 md-large-size-100 ml-auto">
    <ValidationObserver
      class="md-layout-item md-size-60 md-medium-size-100"
      v-slot="{ invalid }"
    >
      <md-card class="md-layout md-layout-item md-size-100">
        <router-link :to="previousLink()">
          <md-button class="md-just-icon md-simple md-round back-button">
            <md-icon>arrow_back</md-icon>
          </md-button>
        </router-link>
        <md-card-header class="header-margin">
          <h3>Posao</h3>
        </md-card-header>

        <md-card-content class="md-layout md-layout-item">
          <ValidationProviderExtended
            name="Naziv posla"
            rules="between:2,50"
            className="md-layout-item md-size-100"
          >
            <label>Naziv posla</label>
            <md-input v-model="job.name" type="text"> </md-input>
          </ValidationProviderExtended>
          <md-field class="md-layout-item md-size-70">
            <search-drop-down
              title="Materijali"
              :items="materials"
              :defaultValue="''"
              :onSelect="
                function () {
                  this.inputString = '';
                }
              "
              @updatedInput="searchLargeFormats"
              @selected="selectItem"
            />
          </md-field>
          <md-field class="md-layout-item md-size-30">
            <md-radio
              v-model="jobType"
              value="ploter"
              @change="searchLargeFormats('')"
            >
              Ploter
            </md-radio>
            <md-radio
              v-model="jobType"
              value="miscellaneous"
              @change="searchLargeFormats('')"
            >
              Ostalo
            </md-radio>
          </md-field>
        </md-card-content>
      </md-card>
      <!-- <md-card
                            v-if="jobItems.length"
                            class="inset-md-card md-layout md-layout-item md-size-100">
                            
                        </md-card> -->
      <md-card v-for="(item, index) in job.jobItems" :key="index">
        <md-button
          class="md-just-icon md-danger md-round close-button ml-auto"
          @click="removeItem(index)"
        >
          <md-icon>delete</md-icon>
        </md-button>
        <md-card-content class="md-layout">
          <md-field
            v-for="(field, fieldIndex) in item.data"
            :key="fieldIndex"
            class="md-layout-item"
            :class="[
              field.color && field.color === 'red' ? 'text-danger' : '',
              field.color && field.color === 'green' ? 'text-success' : '',
              'md-size-' + field.size,
            ]"
          >
            <p v-if="field.type === 'label'" class="form-control-static">
              {{ field.label }}
            </p>
            <div
              v-else-if="field.type === 'input_number'"
              class="md-layout-item"
            >
              <label>
                {{ field.label }}
              </label>
              <md-input
                v-model="item.params[field.name]"
                type="number"
                @blur="sendParam(index)"
              >
              </md-input>
            </div>
            <div v-else-if="field.type === 'checkbox'" class="md-layout-item">
              <md-checkbox
                v-model="item.params[field.name]"
                @change="sendParam(index)"
              >
                {{ field.label }}
              </md-checkbox>
            </div>
            <div
              v-else-if="field.type === 'textarea'"
              class="md-layout-item md-size-100"
            >
              <md-textarea
                class="md-layout-item"
                v-model="item.params[field.name]"
                @blur="sendParam(index)"
                :placeholder="field.label"
              >
              </md-textarea>
            </div>
          </md-field>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-actions>
          <div class="price-and-save">
            <h3 class="">
              {{
                'Cijena ' +
                new Intl.NumberFormat('de-DE', {
                  style: 'currency',
                  currency: 'EUR',
                }).format(!isNaN(job.totalPrice) ? job.totalPrice : 0)
              }}
            </h3>

            <md-button
              v-if="job.jobItems.length"
              :disabled="invalid"
              class="md-success modal-button"
              @click="saveJob"
            >
              <span class="md-label">
                <md-icon class="material-icons">save</md-icon>
              </span>

              Sačuvaj</md-button
            >
          </div>
        </md-card-actions>
      </md-card>
    </ValidationObserver>
    <div class="md-layout-item md-size-30 md-medium-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h3 class="title">Napomena</h3>
        </md-card-header>
        <md-card-content class="md-layout">
          <md-field class="md-layout-item">
            <md-textarea v-model="job.comment"> </md-textarea>
          </md-field>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import api from '../api/api.js';
import services from '@/api/services';
import ValidationProviderExtended from '@/components/ValidationProviderExtended.vue';
export default {
  components: {
    ValidationProviderExtended,
  },
  data() {
    return {
      materials: [],
      jobType: 'ploter',
      confirmed: false,
      job: {
        name: '',
        jobItems: [],
        totalPrice: null,
        comment: '',
      },
    };
  },
  methods: {
    searchLargeFormats(value) {
      if (this.jobType === 'ploter') {
        api
          .get(services.largeFormat.getLargeFormats, {
            loadLargeFormatItems: true,
            search: value,
          })
          .then((data) => {
            this.materials = data;
          })
          .catch((error) => {
            this.alertError(error);
          });
      } else if (this.jobType === 'miscellaneous') {
        api
          .get(services.miscellaneous.getMiscellaneousItems, {
            loadMiscellaneousItems: true,
            search: value,
          })
          .then((data) => {
            this.materials = data;
          })
          .catch((error) => {
            this.alertError(error);
          });
      }
    },
    selectItem(value) {
      if (this.jobType === 'ploter') {
        const requestParams = Object.assign(value, {
          loadLargePrintCard: true,
        });
        api
          .post(services.largeFormat.getLargeFormatCard, requestParams)
          .then((data) => {
            const params = {};
            data.card.forEach((element) => {
              if (element.name) {
                params[element.name] = element.selected;
              }
            });

            this.job.jobItems.push({ params, data: data.card, type: 'ploter' });
            if (data.job && data.job.totalPrice !== undefined)
              this.job.totalPrice = data.job.totalPrice;
          })
          .catch((error) => {
            this.alertError(error);
          });
      } else if (this.jobType === 'miscellaneous') {
        const requestParams = Object.assign(value, {
          loadMiscellaneousCard: true,
        });
        api
          .post(services.miscellaneous.getMiscellaneousItemsCard, requestParams)
          .then((data) => {
            const params = {};
            data.card.forEach((element) => {
              if (element.name) {
                params[element.name] = element.selected;
              }
            });

            this.job.jobItems.push({
              params,
              data: data.card,
              type: 'miscellaneous',
            });
            if (data.job && data.job.totalPrice !== undefined)
              this.job.totalPrice = data.job.totalPrice;
          })
          .catch((error) => {
            this.alertError(error);
          });
      }
    },
    removeItem(index) {
      api
        .post(services.item.removeItem, {
          removeItem: true,
          itemIndex: index,
        })
        .then((data) => {
          this.job.jobItems.splice(index, 1);
          if (data.job && data.job.totalPrice !== undefined)
            this.job.totalPrice = data.job.totalPrice;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    startJob() {
      return api
        .post(services.largeFormat.startLargeFormatJob, { start: true })
        .catch((error) => {
          this.alertError(error);
        });
    },
    sendParam(index) {
      if (this.job.jobItems[index].type === 'ploter') {
        const requestParams = {
          index,
          loadLargePrintCard: true,
          params: JSON.stringify(this.job.jobItems[index].params),
        };
        api
          .post(services.largeFormat.getLargeFormatCard, requestParams)
          .then((data) => {
            const params = {};
            data.card.forEach((element) => {
              if (element.name) {
                params[element.name] = element.selected;
              }
            });

            this.job.jobItems[index].params = params;
            this.job.jobItems[index].data = data.card;
            if (data.job && data.job.totalPrice !== undefined)
              this.job.totalPrice = data.job.totalPrice;
          })
          .catch((error) => {
            this.alertError(error);
          });
      } else if (this.job.jobItems[index].type === 'miscellaneous') {
        const requestParams = {
          index,
          loadMiscellaneousCard: true,
          params: JSON.stringify(this.job.jobItems[index].params),
        };
        api
          .post(services.miscellaneous.getMiscellaneousItemsCard, requestParams)
          .then((data) => {
            const params = {};
            data.card.forEach((element) => {
              if (element.name) {
                params[element.name] = element.selected;
              }
            });

            this.job.jobItems[index].params = params;
            this.job.jobItems[index].data = data.card;
            if (data.job && data.job.totalPrice !== undefined)
              this.job.totalPrice = data.job.totalPrice;
          })
          .catch((error) => {
            this.alertError(error);
          });
      }
    },
    syncJobInfo() {
      this.working = true;
      return this.syncOfferInfo().then((data) => {
        this.confirmed = !!data.offerInfo.confirmed;
        if (!data.offerInfo.job) {
          api
            .post(services.largeFormat.startLargeFormatJob, { start: true })
            .catch((error) => {
              this.alertError(error);
            });
        } else if (this.$route.query.offerId !== null && !data.job) {
          return api
            .post(services.job.editCachedJob, { editJob: true })
            .then((data) => {
              if (data.job && data.job.type && data.job.type !== 'large_format')
                throw 'Not a large print job';
              else {
                this.job.jobItems = data.job.jobItems.map((el) => {
                  return {
                    data: el.data,
                    params: el.params.params,
                    type: el.params.type.match(/^big_print.+/)
                      ? 'ploter'
                      : 'miscellaneous',
                  };
                });
                this.job.totalPrice = data.job.totalPrice;
                this.job.name = data.job.name;
                this.job.comment = data.job.comment;
              }
            })
            .catch((error) => {
              this.alertError(error);
            });
        } else if (this.$route.query.offerId !== null && data.job) {
          this.job.jobItems = data.job.jobItems.map((el) => {
            return {
              data: el.data,
              params: el.params.params,
              type: el.params.type.match(/^big_print.+/)
                ? 'ploter'
                : 'miscellaneous',
            };
          });
          this.job.totalPrice = data.job.totalPrice;
          this.job.name = data.job.name;
          this.job.comment = data.job.comment;

          this.working = false;
          return data;
        } else if (
          data.job &&
          data.job.type &&
          data.job.type === 'large_format'
        ) {
          this.job.jobItems = data.job.jobItems.map((el) => {
            return {
              data: el.data,
              params: el.params.params,
              type: el.params.type.match(/^big_print.+/)
                ? 'ploter'
                : 'miscellaneous',
            };
          });
          this.job.totalPrice = data.job.totalPrice;
          this.job.name = data.job.name;
          this.job.comment = data.job.comment;
        }
      });
    },
    previousLink() {
      const query = { id: this.$route.query.offerId };
      if (this.confirmed) query.filter = 'confirmed';

      return {
        path: 'files',
        query,
      };
    },
    pushToOffers() {
      this.$router.push(this.previousLink());
    },
    saveJob() {
      return api
        .post(services.largeFormat.finishLargeFormatJob, {
          finish: true,
          name: this.job.name,
          comment: this.job.comment,
        })
        .then(() => {
          this.pushToOffers();
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
  },
  mounted() {
    this.syncJobInfo();
  },
};
</script>
<style scoped>
.md-just-icon.close-button {
  position: relative;
  right: 5px;
  bottom: 10px;
}
.price-and-save * {
  margin-right: 0px;
  margin-left: auto;
}
.back-button {
  position: absolute !important;
  top: 0.2em;
  left: 0.5em;
  z-index: 1000;
}
.header-margin {
  margin-top: 1em;
}
</style>
